<template>
    <div class="message-item" :class="[{ user_chat_message: position === 'right' }, `message-item--${position}`]">
        <div class="message-item__plot">
            <span class="message-item__name"> <slot name="username"></slot>: </span>
            <!--            v-if="position === 'left'"-->
            <span class="message-item__txt">
                <slot name="text"></slot>
            </span>
            <time class="message-item__time">
                <slot name="date"></slot>
            </time>
        </div>

        <ul class="files" v-if="Array.isArray(files)">
            <li v-for="file in files">
                <img :src="file" alt="" />
                {{ file | fileName }} - <a :href="file" download>Скачать</a>
            </li>
        </ul>
        <!--<button type="button" class="message-item__delete">
            <v-icon src="close"/>
        </button>-->
    </div>
</template>

<script>
export default {
    name: "ChatMessage",
    filters: {
        fileName(value) {
            if (typeof value === "string") {
                let q = value.split("/");
                return q[q.length - 1];
            }
            return "-";
        }
    },
    props: {
        position: {
            type: String,
            default: "left",
            validator: function(value) {
                return ["left", "right"].indexOf(value) !== -1;
            }
        },
        files: {}
    }
};
</script>

<style lang="scss">
.files {
    padding: 10px 0;
    list-style: none;
    li {
        &:not(:last-child) {
            margin-bottom: 5px;
        }
    }
}

.message-item {
    width: 50%;
    position: relative;
    display: flex;
    flex-direction: column;
    min-height: fit-content;
    * {
        min-height: fit-content;
    }

    /*padding: 8px 20px 8px 16px;
    background: #f5f7fa;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    border-radius: 8px;*/
}

@media (max-width: 812px) {
    .message-item {
        width: calc(100% - 24px);
    }
}

.message-item:not(:last-child) {
    margin-bottom: 40px;
}

@media (max-width: 812px) {
    .message-item:not(:last-child) {
        margin-bottom: 20px;
    }
}

.message-item--left {
    -ms-flex-item-align: start;
    align-self: flex-start;
    margin-left: 20px;

    .message-item__txt {
        font-family: Roboto, sans-serif;
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 20px;

        color: #1d2228;
    }
}

.message-item--right {
    -ms-flex-item-align: end;
    align-self: flex-end;
    margin-right: 20px;
}

.message-item--right .message-item__plot {
    border-radius: 10px 4px 10px 10px;
    background: hsla(0, 0%, 86.3%, 0.2) !important;
    margin-left: auto;
    overflow: hidden;
}

.message-item--right .message-item__time {
    text-align: right;
}

.message-item__plot {
    width: 100%;
    max-width: 600px;
    display: flex;
    flex-direction: column;
    padding: 8px 20px 8px 16px;
    background: #f5f7fa;
    border-radius: 8px;
}

@media (max-width: 812px) {
    .message-item__plot {
        padding: 20px 14px;
    }
}

.message-item__name {
    font-family: Roboto, sans-serif;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 24px;

    color: #9c2cf4;
}

@media (max-width: 812px) {
    .message-item__name {
        color: #000;
        margin-bottom: 10px;
    }
}

.message-item__txt {
    font-family: Roboto, sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 20px;
    word-wrap: break-word;
    color: #1d2228;
}

@media (max-width: 812px) {
    .message-item__txt {
        color: white;
        line-height: 1.2em;
    }
}

.message-item__time {
    font-family: Roboto, sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 20px;
    min-width: 110px;

    color: #58606e;
    align-self: flex-end;
}

.message-item__delete {
    position: absolute;
    top: 16px;
    right: 16px;
    font-size: 16px;
    color: #bdbdbd;
    -webkit-transition: color 0.5s ease;
    transition: color 0.5s ease;
}

@media (max-width: 812px) {
    .message-item__delete {
        color: #ffc107;
    }
}

.message-item__delete:hover {
    color: black;
}

@media (max-width: 812px) {
    .message-item__delete:hover {
        color: #ffc107;
    }
}

.user_chat_message {
    border-radius: 10px 4px 10px 10px;
    .message-item__txt {
        color: #070707;
    }

    .message-item__time {
        font-family: Roboto, sans-serif;
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 20px;
        min-width: 110px;

        color: #58606e;
        align-self: flex-end;
    }
}
</style>
